// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__1V6Fd","NavIcon":"Icon_NavIcon__2ktOZ","Heart":"Icon_Heart__yc2mI","Liked":"Icon_Liked__2Zv_E"};